import {useEffect, useRef} from "react";

export interface UseStandardPollingResult {
    stopPolling: () => void;
}

let timer: any = null;
export default function useStandardPolling(pollingEnabled: boolean, waitMs: number, executable: any): UseStandardPollingResult {
    const pollRequestInProgress = useRef<boolean>(false);

    const stopPolling = () => {
        clearInterval(timer)
    }

    useEffect(() => {
        if (pollingEnabled) {
            timer = setInterval(poll, waitMs);
            return () => clearInterval(timer);
        } // eslint-disable-next-line
    }, [pollingEnabled]);

    const poll = async () => {
        if (pollRequestInProgress.current) {
            return;
        }
        pollRequestInProgress.current = true;
        await executable();
        pollRequestInProgress.current = false;
    }

    return {
        stopPolling: stopPolling
    }
}